// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"4331efba","734":"4331efba","810":"e13c536c"}[chunkId] + ".chunk.css";
};